var _path, _path2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "australia",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.878,
    height: 72.878,
    viewBox: "0 0 72.878 72.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53956",
    "data-name": "Path 53956",
    d: "M236.835,0V72.878a36.439,36.439,0,1,0,0-72.878Z",
    transform: "translate(-200.397)",
    fill: "#252f6b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53957",
    "data-name": "Path 53957",
    d: "M36.438,0a36.439,36.439,0,0,0,0,72.877C56.564,72.877,56.564,0,36.438,0Z",
    fill: "#273375"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46492",
    "data-name": "Group 46492",
    transform: "translate(16.933 16.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53958",
    "data-name": "Path 53958",
    d: "M118.113,329.769l2.457-3.063-3.8.688-1.317-3.677-1.431,3.677-3.876-.688,2.463,3-2.557,2.993,3.9-.612,1.315,3.6,1.432-3.6,3.976.711Z",
    transform: "translate(-110.056 -290.688)",
    fill: "#f3f4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53959",
    "data-name": "Path 53959",
    d: "M326.1,361.782l1.393-1.736-2.152.39-.746-2.083-.811,2.083-2.2-.39,1.4,1.7-1.449,1.7,2.208-.347.745,2.04.811-2.039,2.253.4Z",
    transform: "translate(-288.999 -319.995)",
    fill: "#f3f4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53960",
    "data-name": "Path 53960",
    d: "M326.1,112.476l1.393-1.736-2.152.39-.746-2.083-.811,2.083-2.2-.39,1.4,1.7-1.449,1.7,2.208-.347.745,2.041.811-2.04,2.253.4Z",
    transform: "translate(-288.999 -109.046)",
    fill: "#f3f4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53961",
    "data-name": "Path 53961",
    d: "M384.686,176.969l1.392-1.736-2.151.39-.746-2.083-.811,2.083-2.2-.39,1.4,1.7-1.449,1.7,2.208-.348.745,2.041.811-2.04,2.253.4Z",
    transform: "translate(-338.569 -163.616)",
    fill: "#f3f4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53962",
    "data-name": "Path 53962",
    d: "M275.421,205.643l1.394-1.736-2.152.39-.746-2.083-.811,2.083-2.2-.39,1.4,1.7-1.448,1.7,2.208-.347.745,2.039.811-2.038,2.253.4Z",
    transform: "translate(-246.117 -187.88)",
    fill: "#f3f4f5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46493",
    "data-name": "Group 46493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53963",
    "data-name": "Path 53963",
    d: "M40.754,91.713q-.858,1.105-1.634,2.273h3.906Z",
    transform: "translate(-33.101 -77.602)",
    fill: "#29337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53964",
    "data-name": "Path 53964",
    d: "M172.043,217.533h3.51l-3.51-3.51Z",
    transform: "translate(-145.573 -181.094)",
    fill: "#29337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53965",
    "data-name": "Path 53965",
    d: "M83.105,46.135c-.836.617-1.641,1.271-2.42,1.955l2.42,2.419Z",
    transform: "translate(-68.271 -39.037)",
    fill: "#29337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53966",
    "data-name": "Path 53966",
    d: "M73.6,217.527h3.511v-3.511Z",
    transform: "translate(-62.272 -181.088)",
    fill: "#29337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53967",
    "data-name": "Path 53967",
    d: "M182.012,0a36.418,36.418,0,0,0-9.969,1.392v10.08l9.97-9.969V0Z",
    transform: "translate(-145.573)",
    fill: "#29337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53968",
    "data-name": "Path 53968",
    d: "M209.019,187.18v-5.059H203.96Z",
    transform: "translate(-172.58 -154.101)",
    fill: "#29337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53969",
    "data-name": "Path 53969",
    d: "M1.5,190.54l8.42-8.419H.989A36.477,36.477,0,0,0,0,190.54Z",
    transform: "translate(0 -154.101)",
    fill: "#29337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53970",
    "data-name": "Path 53970",
    d: "M203.938,78.652H209V73.591Z",
    transform: "translate(-172.561 -62.269)",
    fill: "#29337a"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46494",
    "data-name": "Group 46494",
    transform: "translate(0.989 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53971",
    "data-name": "Path 53971",
    d: "M193.211,178.279v-1.063l-5.059-5.059h5.059v-1.812h-7.934Z",
    transform: "translate(-157.76 -145.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53972",
    "data-name": "Path 53972",
    d: "M36.884,91.4H32.978c-.39.591-.761,1.2-1.117,1.81h7.674L34.98,88.658c-.125.155-.247.312-.369.469Z",
    transform: "translate(-27.948 -76.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53973",
    "data-name": "Path 53973",
    d: "M72.49,199.439v3.511H74.3v-6.162l-6.161,6.162h.839Z",
    transform: "translate(-58.644 -167.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53974",
    "data-name": "Path 53974",
    d: "M162.088,9.046q-.916.26-1.81.565V21.777L172.058,10V9.159l-9.97,9.967Z",
    transform: "translate(-136.607 -9.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53975",
    "data-name": "Path 53975",
    d: "M20.209,172.16l.064-.064h0l1.747-1.747H6.906q-.261.9-.478,1.811h8.935l-8.42,8.419H11.79l8.419-8.419Z",
    transform: "translate(-6.428 -145.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53976",
    "data-name": "Path 53976",
    d: "M9.772,190.54l8.42-8.419Z",
    transform: "translate(-9.258 -155.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53977",
    "data-name": "Path 53977",
    d: "M172.39,53.808V52h-5.062l5.062-5.061V42.089L160.671,53.808Z",
    transform: "translate(-136.94 -37.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53978",
    "data-name": "Path 53978",
    d: "M209,73.591l-5.063,5.061Z",
    transform: "translate(-173.549 -63.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53979",
    "data-name": "Path 53979",
    d: "M69.54,43.65l-2.42-2.419q-1.288,1.132-2.467,2.38L69.54,48.5h0l.052.053,1.759,1.759V38.028c-.616.4-1.221.812-1.81,1.247V43.65Z",
    transform: "translate(-55.695 -33.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53980",
    "data-name": "Path 53980",
    d: "M162.085,178.635l3.51,3.51h4.625l-9.946-9.945v9.945h1.811Z",
    transform: "translate(-136.604 -147.098)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46495",
    "data-name": "Group 46495",
    transform: "translate(1.467 1.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53981",
    "data-name": "Path 53981",
    d: "M96.417,106.081l.052.053Z",
    transform: "translate(-83.049 -91.717)",
    fill: "#d32030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53982",
    "data-name": "Path 53982",
    d: "M38.382,38.785l-1.81-1.811H44.5V28.959H32.786l-.06.062v-.062h.06L44.5,17.241V13.109l-11.78,11.78V12.722a36.307,36.307,0,0,0-8.015,3.894V28.9l.063.062H24.71V28.9l-1.759-1.759.01.01H22.9v-.063L18.013,22.2q-1.006,1.065-1.926,2.207l4.554,4.553H12.967a36.166,36.166,0,0,0-3.435,8.015H24.647l.063-.064v.064h-.063L22.9,38.722v.064h-.064L14.417,47.2h4.132l6.161-6.162V47.2h8.015V37.259L42.67,47.2h1.368c.156-.163.315-.324.468-.492V44.907Z",
    transform: "translate(-9.532 -12.722)",
    fill: "#d32030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53983",
    "data-name": "Path 53983",
    d: "M160.274,27.015l11.78-11.78h0Z",
    transform: "translate(-137.081 -14.848)",
    fill: "#d32030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53984",
    "data-name": "Path 53984",
    d: "M96.066,181.767V181.7l-.064.064Z",
    transform: "translate(-82.698 -155.703)",
    fill: "#d32030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53985",
    "data-name": "Path 53985",
    d: "M107.838,169.93l-.063.064h.063Z",
    transform: "translate(-92.66 -145.743)",
    fill: "#d32030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53986",
    "data-name": "Path 53986",
    d: "M160.274,118.319l.061-.062h-.061Z",
    transform: "translate(-137.081 -102.02)",
    fill: "#d32030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53987",
    "data-name": "Path 53987",
    d: "M96.417,106.144h.062l-.01-.01-.052-.053Z",
    transform: "translate(-83.049 -91.717)",
    fill: "#d32030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53988",
    "data-name": "Path 53988",
    d: "M108.249,117.915l-.063-.062v.062Z",
    transform: "translate(-93.008 -101.678)",
    fill: "#d32030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreAustralia);
export default __webpack_public_path__ + "static/media/explore-australia.3cfdf31f05ac25822bfd77cc05868f53.svg";
export { ForwardRef as ReactComponent };